<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pt-5 pt-md-8">
            
    </base-header>
    <div class="card shadow"
            >
      <div class="card-header border-0"
             >
        <div class="row align-items-center">
          <div class="col">
            <h3 class="mb-0">
              Tài Khoản
            </h3>
          </div>

          <div class="col text-right">
            <base-button type="info" class="btn-sm" @click="initCreateUSer">Add</base-button>
                  <modal :show.sync="modals.modal1">
                  <template slot="header">
                  <h5 class="modal-title" id="exampleModalLabel1">Tài Khoản</h5>
                  </template>
                  <div>
                    <base-input v-model="user.username" prepend-icon="ni ni-hat-3" placeholder="Username">
                    </base-input>
                    <base-input v-model="user.fullname" prepend-icon="ni ni-circle-08" placeholder="Họ Tên">
                    </base-input>
                    <div class="row">
                      <div class="col-md-6">
                        <base-input v-model="user.mobile" prepend-icon="ni ni-email-83" placeholder="Mobile">
                        </base-input>
                      </div>
                      <div class="col-md-6">
                        <base-input v-model="user.email" prepend-icon="ni ni-email-83" placeholder="Email">
                        </base-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <base-input type="password" v-model="user.password" prepend-icon="ni ni-email-83" placeholder="Password">
                        </base-input>
                      </div>
                      <div class="col-md-6">
                        <v-select multiple v-model="user.availableIDC" :options="['TTN','NTMK', 'DBP']" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                      <base-input v-model="user.permission" placeholder="Quyền">
                      </base-input>
                      </div>
                      <div class="col-md-6">
                      <base-checkbox class="mb-3" v-model="user.isactive">
                      Enable
                      </base-checkbox>
                      </div>
                    </div>
                  </div>
                  <template slot="footer">
                    <base-button type="secondary" @click="modals.modal1 = false">Close</base-button>
                    <base-button type="primary" @click="createUser">Save</base-button>
                  </template>
                </modal>
          </div>
        </div>
      </div>

      <div class="table-responsive">
              <base-table class="table align-items-center table-flush"
                  
                  
                  tbody-classes="list"
                  :data="users">
                <template slot="columns">
                  <th>User</th>
                  <th>Họ Tên</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Quyền</th>
                  <th>Trạng Thái</th>
                  <th></th>
                </template>

                <template slot-scope="{row}">
                  <th scope="row">
                    <div class="media align-items-center">
                      <div class="media-body">
                        <span class="name mb-0 text-sm">{{row.username}}</span>
                      </div>
                    </div>
                  </th>
                  <td class="budget">
                    {{row.fullname}}
                  </td>
                  <td class="budget">
                    {{row.mobile}}
                  </td>
                  <td class="budget">
                    {{row.email}}
                  </td>
                  <td class="budget">
                    {{row.permission}}
                  </td>
                  <td class="budget">
                    <badge pill v-if="row.isactive" type="info">Active</badge>
                      <badge pill v-else type="danger">Disable</badge>
                  </td>
                  <td class="col-3 text-right">
                    <base-button type="warning" class="btn-sm" @click="editUser(row)">Edit</base-button>
                  <modal :show.sync="modals.modal0">
                  <template slot="header">
                  <h5 class="modal-title">Tài Khoản</h5>
                  </template>
                  <div>
                    <div class="row">
                      <div class="col-md-8">
                        <base-input v-model="user.username" prepend-icon="ni ni-hat-3">
                        </base-input>
                      </div>
                      <div class="col-md-3">
                      <base-checkbox class="mb-3" v-model="user.isactive">
                      Enable
                      </base-checkbox>
                      </div>
                    </div>
                    <base-input v-model="user.fullname" prepend-icon="ni ni-circle-08" placeholder="Họ Tên">
                    </base-input>
                    <div class="row">
                      <div class="col-md-6">
                        <base-input v-model="user.mobile" prepend-icon="ni ni-email-83" placeholder="Mobile">
                        </base-input>
                      </div>
                      <div class="col-md-6">
                        <base-input v-model="user.email" prepend-icon="ni ni-email-83" placeholder="Email">
                        </base-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                      <base-input v-model="user.permission">
                      </base-input>
                      </div>
                      <div class="col-md-6">
                        <base-input type="password" v-model="user.password" prepend-icon="ni ni-email-83" placeholder="Password">
                        </base-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                   
                        <v-select multiple v-model="user.availableIDC" :options="['TTN','NTMK', 'DBP']" />
   
                      
                      </div>
                    </div>
                  </div>
                  <template slot="footer">
                    <base-button type="secondary" @click="modals.modal0 = false">Close</base-button>
                    <base-button type="primary" @click="updateUser()">Update</base-button>
                  </template>
                </modal>
                    <base-button type="danger" class="btn btn-danger btn-sm" @click="deleteUser(row)" >Delete</base-button>
                  </td>
                </template>

              </base-table>
            </div>

    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  data() {
    return {
      user: {},
      users: [],
      modals: {
        modal0: false,
        modal1: false
      },

    }
  },
  methods: {
    async getUsers() {
     let res = await this.$http.get('/users')
     this.users = res.data
    },
    createUser() {
      let data = {
        username: this.user.username,
        email: this.user.email,
        fullname: this.user.fullname,
        mobile:this.user.mobile,
        password: this.user.password,
        permission:  this.user.permission,
        isactive: this.user.isactive,
        availableIDC: this.user.availableIDC
      }
      if(this.user.username && this.user.fullname && this.user.password) {
        this.users.push(data)
        this.$http.post('/users/add', data)
        this.user = {}
        this.modals.modal1 = false
      }
      else {
        this.user = {}
        this.$notify({type:'danger',message:"username, fullname and password is required"})
        this.modals.modal1 = false
      }
    },
    initCreateUSer() {
      this.user  = {}
      this.modals.modal1 = true
    },
    async deleteUser(user) {
      let data = { userid: user._id}
      await this.$http.post('/users/delete', data)
      this.users = _.without(this.users, user)
    },
    async updateUser() {
      await this.$http.post('/users/edit', this.user )
      this.user = {}
      this.modals.modal0 = false
    },
    editUser(user) {
      this.user= user
      this.modals.modal0 = true
    }


  },
  mounted() {
    this.getUsers()
  }
}
</script>
<style>

</style>